import { AppConfig, InternalRoute } from '@/config/links';
import Link from 'next/link';

type SmartLinkProps = {
    type: 'internal' | 'external';
    route: string,
    params?: unknown[],
    children: React.ReactNode;
} & Omit<React.ComponentProps<typeof Link>, 'href'>;

export function SmartLink({
    type,
    route,
    params = [],
    children,
    ...props
}: SmartLinkProps) {
    if (type === 'internal') {
        const routeConfig = AppConfig.routes.internal[route as InternalRoute];
        const path = typeof routeConfig === 'function'
            ? (routeConfig as (...args: unknown[]) => string)(...params)
            : routeConfig;
        return (
            <Link href={path} {...props}>
                {children}
            </Link>
        );
    } else {
        const baseUrl = AppConfig.domains[type];
        const path = AppConfig.routes.external[route as keyof typeof AppConfig.routes.external];
        const url = path.startsWith('http') ? path : `${baseUrl}${path}`;
        return (
            <a
                className='cursor-pointer'
                href={url}
                rel="noopener noreferrer"
                {...props}
            >
                {children}
            </a>
        );
    }


}

